import React, { CSSProperties } from 'react';
import { MuiButton } from '@ui/base_library';
import { makeStyles } from 'tss-react/mui';
import { ProfileBubble } from 'components/UserProfileBubble/UserProfileBubble';

const useStyles = makeStyles()(theme => ({
  container: {
    height: theme.spacing(4),
    width: theme.spacing(4),
    padding: 0,
    minWidth: 0,
    opacity: 0.4,
    '& .MuiButton-label': {
      width: 'unset',
    },
    '&.Mui-focusVisible': {
      ...(theme.mixins.focusOutline as CSSProperties),
      opacity: 1,
      borderRadius: `50%`,
    },
    '&:hover': {
      cursor: 'pointer',
      opacity: 1,
    },
  },
  open: {
    opacity: 1,
  },
}));

export interface UserAvatarButtonProps {
  open: boolean;
  userId: string;
  userInitials: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const UserAvatarButton = React.forwardRef<
  HTMLButtonElement,
  UserAvatarButtonProps
>((props, forwardRef) => {
  const { open, onClick, userId, userInitials } = props;

  const { classes, cx } = useStyles();
  return (
    <MuiButton
      ref={forwardRef}
      tabIndex={0}
      className={cx(classes.container, { [classes.open]: open })}
      data-e2e="action-user-profile-menu-account"
      onClick={onClick}
      aria-label="user profile menu"
    >
      <ProfileBubble userId={userId} initials={userInitials} size="lg" />
    </MuiButton>
  );
});

export default UserAvatarButton;
